// extracted by mini-css-extract-plugin
export default {"flexSpacer":"_62de3789","dealerNav":"_10c6d66a","navHeading":"_77bd5db9","internalNav":"_a52eaff6","logo":"_f4f61183","brand":"_2ae27e53","brandText":"_caeacf6e"};